export const SIZES = {
  XXXS: 280,
  XXS: 360,
  XS: 480,
  XSS: 516,
  SM: 600,
  MD: 720,
  LG: 960,
}

export const CLOSE_TYPES = {
  ICON: 'icon',
  TEXT: 'text',
  NONE: 'none',
}

export const SLIDE_FROM = {
  LEFT: 'right',
  RIGHT: 'left',
  TOP: 'down',
  BOTTOM: 'up',
}
